const MaintenanceBanner = () => {
  return (
    <div className="row" style={{ marginTop: "-20px", width: "100%" }}>
      <div className="col-md-12">
        <style>{`.banner { 
          background-color: #FFCE46;
        color: #222;
        padding: 10px;
        text-align: center;
        font-weight: bold;
        font-size: 18pt;
            }
          `}</style>
        <div className="banner">
          Some functions in LEAP are offline for essential maintenance until 29
          April. Objections may be submitted by email to{" "}
          <a href="mailto:licensing@epa.ie" style={{ fontWeight: "bold" }}>
            licensing@epa.ie
          </a>{" "}
          and Submissions can be made from 29 April onwards, once the system is
          fully restored.
        </div>
      </div>
    </div>
  );
};

const SlimEpaHeader = () => {
  return (
    <header className="header" aria-label="Site header">
      <nav
        className="navbar-expand-xl container-fluid container-t4-xl"
        aria-label="Header navigation"
        style={{ marginTop: "20px" }}
      >
        <MaintenanceBanner />
        <div className="header__container">
          <a href="https://www.epa.ie/" className="navbar-logo">
            <img
              src="https://www.epa.ie/media/epa-2020/site-assets/images/logo/epawebnew.svg"
              alt="Environmental Protection Agency Logo"
            />
          </a>
        </div>
      </nav>
    </header>
  );
};

export { SlimEpaHeader };
